import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/claim/rect.png'


const _withScopeId = n => (_pushScopeId("data-v-d34c8c5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "topCon" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "iconTit" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "iconTitle" }, "Overview")
], -1))
const _hoisted_4 = { class: "overviewCon" }
const _hoisted_5 = {
  class: "tabCon",
  ref: "tabCon"
}
const _hoisted_6 = { class: "resultList" }
const _hoisted_7 = { class: "resultListCon" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resultListTit" }, "Dealer Submitted:", -1))
const _hoisted_9 = { class: "resultListCon" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resultListTit" }, "Unchecked:", -1))
const _hoisted_11 = { class: "resultListCon" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resultListTit" }, "Appeal Unchecked:", -1))
const _hoisted_13 = { class: "resultList" }
const _hoisted_14 = { class: "resultListCon" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resultListTit" }, "Submitted:", -1))
const _hoisted_16 = { class: "resultListCon" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resultListTit" }, "Auto Checked:", -1))
const _hoisted_18 = { class: "resultListCon" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resultListTit" }, "Checked:", -1))
const _hoisted_20 = {
  key: 0,
  class: "btnCon"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Sampling")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Batch Download Documents")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Export Search Result")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Upload Checking result")
const _hoisted_25 = {
  key: 1,
  class: "btnCon"
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Export Search Result")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Batch Submit")
const _hoisted_28 = { class: "table-box" }
const _hoisted_29 = {
  key: 0,
  class: "tableCon"
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Check")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("View")
const _hoisted_32 = {
  key: 1,
  class: "tableCon"
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Sumbit")
const _hoisted_34 = {
  key: 0,
  class: "bottom"
}
const _hoisted_35 = {
  key: 1,
  class: "bottom"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_search_list = _resolveComponent("search-list")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_over_list = _resolveComponent("over-list")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_upload_files = _resolveComponent("upload-files")!
  const _component_notice_modal = _resolveComponent("notice-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, {
      dataSource: [],
      class: "titleDC"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["whiteBG", { secondBG: _ctx.activeKey == '2' }])
            }, null, 2),
            _createVNode(_component_a_tabs, {
              type: "card",
              activeKey: _ctx.activeKey,
              "onUpdate:activeKey": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.activeKey) = $event)),
              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeTab($event)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, {
                  key: "1",
                  tab: "Check"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("div", {
                          class: "resultListNum",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCheckingRes(1)))
                        }, _toDisplayString(_ctx.overViewNum.totalSubmit), 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("div", {
                          class: "resultListNum",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCheckingRes(2)))
                        }, _toDisplayString(_ctx.overViewNum.unChecked), 1)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("div", {
                          class: "resultListNum",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCheckingRes(3)))
                        }, _toDisplayString(_ctx.overViewNum.appealUnChecked), 1)
                      ])
                    ]),
                    _createVNode(_component_search_list, {
                      ref: "searchList",
                      onGetTableData: _ctx.refreshTableData,
                      onRefreshTableHeight: _ctx.refreshTableHeight,
                      onInitTable: _ctx.initTable,
                      onResetStatus: _ctx.resetStatus
                    }, null, 8, ["onGetTableData", "onRefreshTableHeight", "onInitTable", "onResetStatus"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "2",
                  tab: "Submit"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("div", {
                          class: "resultListNum",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setCheckingSub(1)))
                        }, _toDisplayString(_ctx.overViewNum.submitted), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", {
                          class: "resultListNum",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setCheckingSub(2)))
                        }, _toDisplayString(_ctx.overViewNum.autoChecked), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", {
                          class: "resultListNum",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setCheckingSub(3)))
                        }, _toDisplayString(_ctx.overViewNum.checked), 1)
                      ])
                    ]),
                    _createVNode(_component_over_list, {
                      ref: "overlist",
                      onRefreshTableHeight: _ctx.refreshTableHeight,
                      onGetTableDataOrder: _ctx.refreshSumbitTableData
                    }, null, 8, ["onRefreshTableHeight", "onGetTableDataOrder"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeKey"])
          ], 512),
          (_ctx.activeKey == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (_ctx.$btnPermissions('VL0009'))
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      class: "button",
                      onClick: _ctx.gotoSampling
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.$btnPermissions('VL0010'))
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 1,
                      class: "button",
                      disabled: _ctx.isClick,
                      onClick: _ctx.downloadBatchDoc
                    }, {
                      default: _withCtx(() => [
                        _hoisted_22
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.$btnPermissions('VL0011'))
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 2,
                      class: "button",
                      disabled: _ctx.isClick,
                      onClick: _ctx.exportDoc
                    }, {
                      default: _withCtx(() => [
                        _hoisted_23
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.$btnPermissions('VL0012'))
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 3,
                      type: "primary",
                      class: "button",
                      onClick: _ctx.openUploadModal
                    }, {
                      default: _withCtx(() => [
                        _hoisted_24
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                (_ctx.$btnPermissions('VL0016'))
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      class: "button",
                      onClick: _ctx.exportSearch
                    }, {
                      default: _withCtx(() => [
                        _hoisted_26
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.$btnPermissions('VL0017'))
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 1,
                      type: "primary",
                      class: "button",
                      onClick: _ctx.batchSumbitEvent
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        (_ctx.activeKey == '1')
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createVNode(_component_a_table, {
                columns: _ctx.columns,
                pagination: false,
                dataSource: _ctx.tableData,
                rowKey: (record, index) => index,
                scroll: { x: _ctx.tableWidth, y: _ctx.tableHeight },
                rowClassName: 
            (record, index) => (index % 2 === 1 ? 'table-striped' : null)
          
              }, {
                isModified: _withCtx(({ record }) => [
                  _createTextVNode(_toDisplayString(record.isModified == 1 ? "Y" : "N"), 1)
                ]),
                checkStatus: _withCtx(({ record }) => [
                  _createTextVNode(_toDisplayString(_ctx.EnumCheckStatus[record.checkStatus]), 1)
                ]),
                operation: _withCtx(({ record }) => [
                  _createVNode(_component_a_button, {
                    type: "link",
                    style: {"margin-right":"5px"},
                    disabled: _ctx.checkDisabled(record),
                    onClick: ($event: any) => (_ctx.gotoCheckingDetail(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_30
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"]),
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (_ctx.gotoCheckingDetail(record, false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_31
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              }, 8, ["columns", "dataSource", "rowKey", "scroll", "rowClassName"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeKey == '2')
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createVNode(_component_a_table, {
                columns: _ctx.columns,
                pagination: false,
                dataSource: _ctx.tableDataSumbit,
                rowKey: (record, index) => index,
                scroll: { x: _ctx.tableWidth, y: _ctx.tableHeight },
                rowClassName: 
            (record, index) => (index % 2 === 1 ? 'table-striped' : null)
          
              }, {
                isModified: _withCtx(({ record }) => [
                  _createTextVNode(_toDisplayString(record.isModified == 1 ? "Y" : "N"), 1)
                ]),
                checkStatus: _withCtx(({ record }) => [
                  _createTextVNode(_toDisplayString(_ctx.EnumCheckStatus[record.checkStatus]), 1)
                ]),
                operation: _withCtx(({ record }) => [
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (_ctx.gotoCheckingDetailSubmit(record)),
                    disabled: 
                record.licenseCheckStatus !== 'SICCO Init' &&
                record.licenseCheckStatus !== 'SIPO Rejected'
              
                  }, {
                    default: _withCtx(() => [
                      _hoisted_33
                    ]),
                    _: 2
                  }, 1032, ["onClick", "disabled"])
                ]),
                _: 1
              }, 8, ["columns", "dataSource", "rowKey", "scroll", "rowClassName"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.tableData && _ctx.tableData.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createVNode(_component_a_pagination, {
            total: _ctx.pagination.total,
            "show-size-changer": "",
            "show-total": (total) => `共 ${total} 条`,
            onChange: _ctx.pageChange,
            onShowSizeChange: _ctx.sizeChange,
            current: _ctx.pagination.currentPage,
            "onUpdate:current": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pagination.currentPage) = $event)),
            pageSize: _ctx.pagination.pageSize,
            "onUpdate:pageSize": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pagination.pageSize) = $event)),
            pageSizeOptions: ['10', '20', '30', '40', '50']
          }, {
            buildOptionText: _withCtx((props) => [
              _createElementVNode("span", null, _toDisplayString(props.value) + "条/页", 1)
            ]),
            _: 1
          }, 8, ["total", "show-total", "onChange", "onShowSizeChange", "current", "pageSize"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.activeKey == '2')
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createVNode(_component_a_pagination, {
            total: _ctx.totalSumbit,
            "show-size-changer": "",
            "show-total": (totalSumbit) => `共 ${totalSumbit} 条`,
            onChange: _ctx.pageSumbitChange,
            onShowSizeChange: _ctx.sizeSumbitChange,
            current: _ctx.currentPage,
            "onUpdate:current": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentPage) = $event)),
            pageSize: _ctx.pageSumbitSize,
            "onUpdate:pageSize": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.pageSumbitSize) = $event)),
            pageSizeOptions: ['10', '20', '30', '40', '50']
          }, {
            buildOptionText: _withCtx((props) => [
              _createElementVNode("span", null, _toDisplayString(props.value) + "条/页", 1)
            ]),
            _: 1
          }, 8, ["total", "show-total", "onChange", "onShowSizeChange", "current", "pageSize"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isUploadVisible)
      ? (_openBlock(), _createBlock(_component_upload_files, {
          key: 2,
          isUploadVisible: _ctx.isUploadVisible,
          onCloseUploadVisible: _ctx.closeUpload,
          onGetModalInfo: _ctx.getModalInfo
        }, null, 8, ["isUploadVisible", "onCloseUploadVisible", "onGetModalInfo"]))
      : _createCommentVNode("", true),
    (_ctx.modalVisible)
      ? (_openBlock(), _createBlock(_component_notice_modal, {
          key: 3,
          modalVisible: _ctx.modalVisible,
          submitLabel: "Confirm",
          cancelLabel: "Cancel",
          modalData: _ctx.modalData,
          onCloseModalVisible: _ctx.closeModal
        }, null, 8, ["modalVisible", "modalData", "onCloseModalVisible"]))
      : _createCommentVNode("", true)
  ], 64))
}